/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";
import { useWorkingHours } from "./WorkingHoursContext";

const ChefOfflinePopup = () => {
  const { showOfflinePopup, setShowOfflinePopup } = useWorkingHours();

  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes = 120 seconds

  // Countdown logic
  useEffect(() => {
    if (!showOfflinePopup) return;

    setTimeLeft(120); // reset every time popup shows

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showOfflinePopup]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  if (!showOfflinePopup) return null;

  return (
    <Modal show={showOfflinePopup} centered>
      <div className="p-4">
        <h4 className="fw-bold text-center mb-3">⚠️ Working Hours Alert</h4>

        <p className="text-center">
          Working hours almost up! You’ll go{" "}
          <strong style={{ color: "red" }}>Offline</strong> in 2 minutes. <br />
          Change your status manually if you want to stay Online.
        </p>

        {/* Timer */}
        <div className="text-center my-3">
          <strong style={{ fontSize: "1.5rem", color: "red" }}>
            {minutes}:{seconds.toString().padStart(2, "0")}
          </strong>
        </div>

        {/* Progress bar as loading visual */}
        <ProgressBar
          now={(timeLeft / 120) * 100}
          variant="danger"
          animated
          striped
        />

        <Modal.Footer className="justify-content-center">
          <Button
            variant="success"
            onClick={() => setShowOfflinePopup(false)}
            className="rounded-pill px-4"
          >
            Got it
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default ChefOfflinePopup;
